export const rows = [
  {
    id: 5,
    name: "Johan",
    vehicleNumber: "1629",
    dateTime: "2022-03-22",
    vehicleType: "Truck",
    typeOfConsignment: "Cargo",
    resident: "ISB",
    cargoType: "Liquid",
    actionButtons: "",
    gd: "123",
  },
  {
    id: 10,
    name: "Johan",
    vehicleNumber: "1629",
    dateTime: "2022-03-22",
    vehicleType: "Truck",
    typeOfConsignment: "Cargo",
    resident: "ISB",
    cargoType: "Liquid",
    actionButtons: "",
    gd: "123",
  },
];
